import { method } from "lodash";

const luckyprefix = "/api/v1/luckydefence";

const luckytype = "luckytype";

const luckyurls = {
  allPlayers: {
    path:(name,id,num,page)=>`/players?name=${name}&id=${id}&num=${num}&page=${page}`,
    method: "GET"
  },
  playerInfo:{
    path:(id)=>{return `/player/${id}`},
    method:"GET",
 }, 
 createShopTicket:{
   path:  "/createticket",
   method:"POST",
 },
  allTickets:{
   path:"/tickets",
   method:"GET",
 },
 getAllItem:{
  path:"/allitems",
   method:"GET",
 },
  addMail:{
  path:"/addmail",
   method:"POST",
 },
  delMail:{
  path:(id)=>`/delmail/${id}`,
   method:"GET",
 },
  getAllMails:{
  path:"/allmails",
   method:"GET",
 },
  publicMail:{
   path:(id)=>`/publishmail/${id}`,
   method:"GET",
  },
  takedown:{
   path:(id)=>`/takedown/${id}`,
   method:"GET",
  },
  dailySummary:{
     path:(start,end)=>`/dailysummary?start=${start}&end=${end}`,
     method:"GET",
  },
  recentlyOrder :{ 
    path:"/recentlyrecharges",
    method:"GET",
  },
  generateEqStr:{
    path:"/createEqString",
    method:"POST"
  },
  createActiveCode:{
    path:"/createActiveCode",
    method:"GET"
  },
   getActiveCode:{
    path:"/getAllActiveCode",
    method:"GET"
  },
  delActiveCode:{
    path:(code)=>`/delActiveCode?code=${code}`,
    method:"GET"
  },
  leaderboard1:{
    path:(id,mapMode)=>`/lb1/${id}?mapMode=${mapMode}`,
    method:"GET"
  },
  activePlayer:{
    path:(id)=>`/active/${id}`,
    method:"GET"
  },
  status:{
    path:"/status",
    method:"GET"
  },
  collectShopTicket:{
    path:"/collectShopTicket",
    method:"POST"
  },
  changeSteamId:{
    path:"/changeId",
    method:"POST"
  }
}

export { luckyprefix, luckyurls, luckytype }
